import { render, staticRenderFns } from "./BSDeviceList.vue?vue&type=template&id=78aafe44&"
import script from "./BSDeviceList.vue?vue&type=script&lang=js&"
export * from "./BSDeviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports